import { useApiQuery } from 'hooks/useApiQuery'
import { removeUndefined } from 'utils/util'

export const useGetNumberLocationPrizeEntries = ({
  contestId,
  licensedEstablishmentId,
}: {
  contestId?: number
  licensedEstablishmentId?: number
}) => {
  const queryArgs = removeUndefined({ contestId, licensedEstablishmentId })

  return useApiQuery({
    method: 'get',
    path: '/admin/contests/entries/contest/{contestId}/licensed-establishment/{licensedEstablishmentId}/total-entries',
    queryKey: [
      '/admin/contests/entries/contest/{contestId}/licensed-establishment/{licensedEstablishmentId}/total-entries',
    ],
    queryArgs,
  })
}
